
export const loadMessages = async (localeToLoad) => {
switch (localeToLoad) {
case 'sr-RS/messages.js_':  return (await import("./sr-RS/messages")).messages;
case 'cs-CZ/messages.js_':  return (await import("./cs-CZ/messages")).messages;
case 'fr-FR/messages.js_':  return (await import("./fr-FR/messages")).messages;
case 'fr-CA_countrymalt':  return (await import("./fr-CA-countrymalt/messages")).messages;
case 'pl-PL_farmi':  return (await import("./pl-PL-farmi/messages")).messages;
case 'en-CA_countrymalt':  return (await import("./en-CA-countrymalt/messages")).messages;
case 'ro-RO/messages.js_':  return (await import("./ro-RO/messages")).messages;
case 'hr-HR/messages.js_':  return (await import("./hr-HR/messages")).messages;
case 'sr-RS_farmi':  return (await import("./sr-RS-farmi/messages")).messages;
case 'fr-CA/messages.js_':  return (await import("./fr-CA/messages")).messages;
case 'ro-RO_farmi':  return (await import("./ro-RO-farmi/messages")).messages;
case 'bg-BG_farmi':  return (await import("./bg-BG-farmi/messages")).messages;
case 'en-US_farmi':  return (await import("./en-US-farmi/messages")).messages;
case 'pl-PL/messages.js_':  return (await import("./pl-PL/messages")).messages;
case 'en-US/messages.js_':  return (await import("./en-US/messages")).messages;
case 'uk-UA/messages.js_':  return (await import("./uk-UA/messages")).messages;
case 'fr-FR_farmi':  return (await import("./fr-FR-farmi/messages")).messages;
case 'cs-CZ_farmi':  return (await import("./cs-CZ-farmi/messages")).messages;
case 'fr-FR_episens':  return (await import("./fr-FR-episens/messages")).messages;
case 'en-CA/messages.js_':  return (await import("./en-CA/messages")).messages;
case 'hr-HR_farmi':  return (await import("./hr-HR-farmi/messages")).messages;
case 'en-US_countrymalt':  return (await import("./en-US-countrymalt/messages")).messages;
case 'sk-SK/messages.js_':  return (await import("./sk-SK/messages")).messages;
case 'sk-SK_farmi':  return (await import("./sk-SK-farmi/messages")).messages;
case 'uk-UA_farmi':  return (await import("./uk-UA-farmi/messages")).messages;
case 'bg-BG/messages.js_':  return (await import("./bg-BG/messages")).messages;
case 'fr-FR_aladin':  return (await import("./fr-FR-aladin/messages")).messages;
}; };
